import React, { useState, useEffect } from 'react';
import api from '../../services/api';

function StarDisplay({ rating }) {
  if (!rating) return <span style={{ fontSize: 12, color: '#b0a090' }}>Sin calificaciones</span>;
  const r = Math.round(parseFloat(rating));
  return (
    <span>
      <span style={{ color: '#f59e0b', fontSize: 14 }}>{'★'.repeat(r)}{'☆'.repeat(5 - r)}</span>
      <span style={{ color: '#7a7060', fontSize: 12, marginLeft: 4 }}>{parseFloat(rating).toFixed(1)}</span>
    </span>
  );
}

function AgentCard({ agent, onAssign, orderRef }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div style={{ background: '#fff', border: '1px solid #e2dbd0', borderRadius: 14, overflow: 'hidden', marginBottom: 10 }}>
      <div style={{ padding: '18px 20px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        onClick={() => setExpanded(!expanded)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ position: 'relative' }}>
            <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#f0ebe2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>🤝</div>
            <div style={{ position: 'absolute', bottom: 0, right: 0, width: 12, height: 12, borderRadius: '50%', background: agent.is_online ? '#2d6a4f' : '#b0a090', border: '2px solid #fff' }} />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 2 }}>{agent.full_name}</div>
            <div style={{ fontSize: 12, color: '#7a7060' }}>
              {[agent.city, agent.province, agent.country].filter(Boolean).join(', ')}
            </div>
            <div style={{ marginTop: 4 }}>
              <StarDisplay rating={agent.rating} />
            </div>
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 20, color: '#0f0d0b', marginBottom: 2 }}>
            {agent.total_delivered || 0}
          </div>
          <div style={{ fontSize: 11, color: '#7a7060' }}>entregas</div>
          <div style={{ fontSize: 11, color: expanded ? '#c94a1e' : '#7a7060', marginTop: 4 }}>
            {expanded ? '▲ menos' : '▼ más'}
          </div>
        </div>
      </div>

      {expanded && (
        <div style={{ borderTop: '1px solid #f0ebe2', padding: '16px 20px' }}>
          {/* Coverage zone */}
          {agent.coverage_zone && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 4 }}>Zona de cobertura</div>
              <div style={{ fontSize: 13, color: '#4a4035' }}>{agent.coverage_zone}</div>
            </div>
          )}

          {/* Delivery methods */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 6 }}>Métodos de entrega</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {(typeof agent.delivery_methods === 'string'
                ? agent.delivery_methods.replace(/[\[\]'"]/g, '').split(',').map(s => s.trim())
                : agent.delivery_methods || []
              ).map((m, i) => (
                <span key={i} style={{ padding: '3px 10px', borderRadius: 20, background: '#f0ebe2', fontSize: 12, fontWeight: 600 }}>
                  {m === 'cash' ? '💵 Efectivo' : m === 'transfermovil' ? '📱 Transfermóvil' : m === 'cubacel' ? '📶 Cubacel' : m}
                </span>
              ))}
            </div>
          </div>

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 14 }}>
            {[
              { label: 'Rating', value: agent.rating ? `${parseFloat(agent.rating).toFixed(1)}★` : '—' },
              { label: 'Entregas', value: agent.total_delivered || 0 },
              { label: 'Cap. diaria', value: agent.daily_capacity_usd ? `$${agent.daily_capacity_usd}` : '—' },
            ].map((s, i) => (
              <div key={i} style={{ background: '#f9f6f1', borderRadius: 8, padding: '10px 8px', textAlign: 'center' }}>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#c94a1e' }}>{s.value}</div>
                <div style={{ fontSize: 11, color: '#7a7060' }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Recent ratings */}
          {agent.recent_ratings?.length > 0 && (
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 8 }}>Opiniones recientes</div>
              {agent.recent_ratings.map((r, i) => (
                <div key={i} style={{ padding: '8px 0', borderBottom: '1px solid #f0ebe2', fontSize: 13 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                    <span style={{ color: '#f59e0b' }}>{'★'.repeat(r.stars)}</span>
                    <span style={{ fontSize: 11, color: '#b0a090' }}>
                      {r.created_at ? new Date(r.created_at).toLocaleDateString('es-ES') : '—'}
                    </span>
                  </div>
                  {r.comment && <div style={{ color: '#4a4035', fontSize: 12 }}>{r.comment}</div>}
                </div>
              ))}
            </div>
          )}

          {/* Assign button */}
          {orderRef && onAssign && (
            <button
              onClick={() => onAssign(agent.id, agent.full_name)}
              style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: '#c94a1e', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
              Asignar a mi orden →
            </button>
          )}

          {agent.telegram_username && (
            <div style={{ textAlign: 'center', marginTop: 10, fontSize: 12, color: '#7a7060' }}>
              Telegram: <a href={`https://t.me/${agent.telegram_username.replace('@', '')}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1a4e8c' }}>{agent.telegram_username}</a>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function BrowseAgents({ orderRef, onAssigned }) {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ country: '', province: '', delivery_method: '', min_rating: '' });
  const [assigning, setAssigning] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.country) params.country = filters.country;
      if (filters.province) params.province = filters.province;
      if (filters.delivery_method) params.delivery_method = filters.delivery_method;
      if (filters.min_rating) params.min_rating = filters.min_rating;

      const res = await api.get('/api/v1/marketplace/agents', { params });
      // Fetch profiles with ratings for top agents
      const agentsList = Array.isArray(res.data) ? res.data : [];

      // Get detailed profiles for first 10
      const detailed = await Promise.all(
        agentsList.slice(0, 10).map(a =>
          api.get(`/api/v1/marketplace/agents/${a.id}`).then(r => r.data).catch(() => a)
        )
      );
      setAgents([...detailed, ...agentsList.slice(10)]);
    } catch { setAgents([]); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleAssign = async (agentId, agentName) => {
    if (!orderRef) return;
    if (!window.confirm(`¿Asignar a ${agentName} para tu orden ${orderRef}?`)) return;
    setAssigning(agentId);
    try {
      await api.post(`/api/v1/marketplace/orders/${orderRef}/assign/${agentId}`);
      alert(`✅ Orden asignada a ${agentName}`);
      onAssigned && onAssigned();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al asignar agente');
    } finally { setAssigning(null); }
  };

  const setFilter = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  return (
    <div>
      {!orderRef && (
        <div style={{ marginBottom: 20 }}>
          <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 26, margin: '0 0 4px' }}>Agentes disponibles</h1>
          <p style={{ fontSize: 13, color: '#7a7060' }}>Elige un agente de confianza para tu próxima orden</p>
        </div>
      )}

      {/* Filters */}
      <div style={{ background: '#fff', border: '1px solid #e2dbd0', borderRadius: 12, padding: 16, marginBottom: 16, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        {[
          { key: 'country', label: 'País', placeholder: 'CU', width: 80 },
          { key: 'province', label: 'Provincia', placeholder: 'La Habana' },
        ].map(f => (
          <div key={f.key}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 4 }}>{f.label}</div>
            <input style={{ padding: '8px 12px', border: '1px solid #e2dbd0', borderRadius: 8, fontSize: 13, outline: 'none', width: f.width || 140 }}
              placeholder={f.placeholder}
              value={filters[f.key]} onChange={e => setFilter(f.key, e.target.value)} />
          </div>
        ))}
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 4 }}>Entrega</div>
          <select style={{ padding: '8px 12px', border: '1px solid #e2dbd0', borderRadius: 8, fontSize: 13, outline: 'none' }}
            value={filters.delivery_method} onChange={e => setFilter('delivery_method', e.target.value)}>
            <option value="">Todos</option>
            <option value="cash">💵 Efectivo</option>
            <option value="transfermovil">📱 Transfermóvil</option>
            <option value="cubacel">📶 Cubacel</option>
          </select>
        </div>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 4 }}>Rating mín.</div>
          <select style={{ padding: '8px 12px', border: '1px solid #e2dbd0', borderRadius: 8, fontSize: 13, outline: 'none' }}
            value={filters.min_rating} onChange={e => setFilter('min_rating', e.target.value)}>
            <option value="">Cualquiera</option>
            <option value="3">3★+</option>
            <option value="4">4★+</option>
            <option value="4.5">4.5★+</option>
          </select>
        </div>
        <button onClick={load} style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: '#c94a1e', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
          Buscar
        </button>
      </div>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#7a7060' }}>Buscando agentes...</div>
      ) : agents.length === 0 ? (
        <div style={{ background: '#fff', borderRadius: 14, padding: 48, textAlign: 'center', border: '1px solid #e2dbd0' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
          <div style={{ fontSize: 15, color: '#7a7060' }}>No hay agentes con esos filtros</div>
        </div>
      ) : agents.map((agent, i) => (
        <AgentCard
          key={i}
          agent={agent}
          orderRef={orderRef}
          onAssign={orderRef ? handleAssign : null}
        />
      ))}
    </div>
  );
}
